module.exports = __webpack_public_path__ + "img/feature-9.fe5b6228.jpg";